<template>
  <div class="component">
    <b-container fluid class="pb-30 pt-30">
      <b-row>
        <b-col cols="10">
          <b-row class="fs-20">
            <b>New Site</b>
          </b-row>
          <b-form @submit.prevent="validateBeforeSubmit">
            <!-- Institution -->
            <b-row class="form-card mt-15">
              <b-col cols="12" class="sec_text fs-16 pb-10">
                <b>Institution</b>
              </b-col>
              <b-col cols="6">
                <span class="header-text">Site Name</span>
                <b-form-input
                  type="text"
                  class="required"
                  v-model="newSite.name"
                  placeholder="Enter name"
                  name="siteName"
                  v-validate="'required'"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.has('siteName')
                  }"
                ></b-form-input>
                <span v-if="errors.has('siteName')" class="error-style">Site name is required.</span>
              </b-col>
              <b-col cols="3">
                <span class="header-text">Site ID</span>
                <b-form-input
                  type="text"
                  class="required"
                  v-model="newSite.userSiteId"
                  placeholder="Enter ID"
                  name="userSiteId"
                  v-validate="'required'"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.has('userSiteId')
                  }"
                ></b-form-input>
                <span v-if="errors.has('userSiteId')" class="error-style">Site ID is required.</span>
              </b-col>
              <b-col cols="3">
                <span class="header-text">Site Type</span>
                <b-form-select
                  :options="siteTypes"
                  class="select-arrow"
                  v-validate="'required'"
                  v-model="newSite.type"
                  name="type"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.has('type')
                  }"
                ></b-form-select>
                <span v-if="errors.has('type')" class="error-style">Site type is required.</span>
              </b-col>
              <b-col cols="3 pt-15">
                <span class="header-text">Site Sub-type</span>
                <b-form-select
                  :options="siteSubTypes"
                  class="select-arrow"
                  v-validate="'required'"
                  v-model="newSite.siteSubType"
                  name="siteSubType"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.has('siteSubType')
                  }"
                ></b-form-select>
                <span v-if="errors.has('siteSubType')" class="error-style">Site Sub-type is required.</span>
              </b-col>
              <b-col cols="3 pt-15" class="custom-width-country">
                <b-form-group
                  id="site-country-label"
                  label-for="siteCountry"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.first('siteCountry')
                  }"
                  :state="!errors.has('siteCountry')"
                >
                  <span class="header-text"
                    >Site country
                    <span
                      v-b-popover.hover.html="'The <strong>site country</strong> is the country participants will be associated with when enrolled. If the site is associated to multiple countries, they can be added by clicking “Add another country.” When multiple countries are added, participants will choose which country to associate themselves with during enrollment.'"
                      class="fa fa-info-circle ml-7"
                    ></span
                  ></span>
                  <b-form-select
                    @change.native="selectPrimary($event)"
                    v-validate="'required'"
                    :options="primaryCountryOptions"
                    class="select-arrow"
                    v-model="newSite.primaryCountry"
                    :state="!errors.has('siteCountry')"
                    key="site-country-input"
                    id="siteCountry"
                    name="siteCountry"
                    v-bind:class="{
                      input: true,
                      'is-danger': errors.first('siteCountry')
                    }"
                  ></b-form-select>
                  <span v-if="errors.first('siteCountry')" class="error-style">Site country is required.</span>
                </b-form-group>
              </b-col>
              <!---approved language--->
              <div class="form-group col-md-4 pt-15" @blur="open = false">
                <div class="multiselect filter-form-box" id="languageSelectBox">
                  <div class="selectBox">
                    <span class="header-text">Approved Languages</span>
                    <div
                      class="fakeclass select-arrow cursor-pointer d-block"
                      :class="{
                        open: open,
                        input: true,
                        'is-danger': errors.first('approvedLanguage')
                      }"
                      :state="!errors.has('approvedLanguage')"
                      @click="open = !open"
                    >
                      <span v-if="this.selectedLanguages && this.selectedLanguages.length">
                        <span v-if="this.selectedLanguages.length == 1 && !!selectedLanguages[0]">
                          {{ this.selectedLanguages[0].display_name }}
                        </span>
                        <span v-else>
                          Selected
                          <span class="number-badge">{{ this.selectedLanguages.length }}</span>
                        </span>
                      </span>
                      <span v-else>
                        Select language(s)
                      </span>
                    </div>
                    <span v-show="errors.has('approvedLanguage')" class="error-style">Approved languages are required.</span>
                    <div class="overSelect"></div>
                  </div>
                  <div id="showCheckboxesLanguage" class="select-scroll activity-builder-select-options" :class="{ selectHide: !open }" v-if="isDisplayApprovedLanguageCheckBoxes">
                    <div class="check_label_input d-flex custom-control custom-checkbox" v-for="language in approvedLanguage" :key="language.language_id">
                      <div v-if="!!language">
                        <input class="custom-control-input" v-validate="selectedLanguages.length == 0 ? 'required' : ''" :id="language.language_id" @input="onChangeLanguageFilter(language, newSite.primaryCountry)" type="checkbox" :value="language" v-model="selectedLanguages" name="approvedLanguage" />
                        <label class="custom-control-label checkbox-label" :for="language.language_id">{{ language.display_name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!---End approved language--->
              <b-row class="pt-15" v-show="filterCountriesOptions.length > 0" v-for="(item, index) in newSite.countryList" :key="`additional-approved-language-${index}`">
                <b-col cols="5">
                  <span class="header-text">Additional Country</span>
                  <b-form-select @change.native="selectCountry($event, index)" :options="filterCountriesOptions[index]" class="select-arrow2" v-model="item.id" name="country"></b-form-select>
                </b-col>
                <b-col cols="5">
                  <approved-language-select :path="$route.path.includes('/research-site/create')" :options="approvedLanguages[item.id]" :countryId="item.id" :updateParentOpen="updateParentOpen" @additionalLanguage="selectedCountryLanguage($event)" />
                </b-col>
                <b-col
                  cols="2"
                  :class="{
                    'mt-30': newSite.countryList.length < 3,
                    'mt-44': newSite.countryList.length > 3,
                    'mt-16': newSite.countryList.length == 3
                  }"
                  v-if="newSite.countryList.length >= 1"
                >
                  <b-link @click="removeCountry($event, index)" class="link-color pt-10"><b>Remove</b></b-link>
                </b-col>
              </b-row>

              <b-col
                v-if="newSite.type && newSite.type.toLowerCase() == 'virtual'"
                cols="4"
                :class="{
                  'mt-43': newSite.countryList.length < 2,
                  'mt-16': newSite.countryList.length >= 2
                }"
                class="pr-0"
              >
                <label for="allowPartFromAnyRegion" class="fw-normal">
                  <input type="checkbox" name="allowPartFromAnyRegion" id="allowPartFromAnyRegion" class="checkbox_position" v-model="siteVirtualAddress.isAllowOtherRegionParticipant" />
                  <span><strong>Allow participants from any region</strong></span
                  ><span v-b-popover.hover.html="'Site available to all participants from any location'" class="fa fa-info-circle ml-7"></span>
                </label>
              </b-col>
              <b-col cols="12 pt-16"
                ><b-link @click="addCountry()" class="pt-10"><b>Add another country</b></b-link></b-col
              >

              <b-col cols="12" class="p-0">
                <!-- VIRTUAL ADDRESS CONTAINER STARTS HERE -->
                <div v-if="newSite.type && newSite.type.toLowerCase() == 'virtual'" id="virtual-site-container" class="site-address-elements">
                  <b-row>
                    <b-col cols="4">
                      <b-form-group id="virtual-city-label" label="City" label-for="virtualSiteCity" :invalid-feedback="errors.first('virtualSiteCity')" :state="!errors.has('virtualSiteCity')">
                        <b-form-input type="text" placeholder="City" v-validate="'alpha_spaces'" id="virtualSiteCity" name="virtualSiteCity" v-model="siteVirtualAddress.city" :state="!errors.has('virtualSiteCity')" key="virtual-city-input"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3">
                      <b-form-group id="virtual-state-label" label="State / Province" label-for="virtualSiteState" :invalid-feedback="errors.first('virtualSiteState')" :state="!errors.has('virtualSiteState')">
                        <b-form-input type="text" placeholder="State / Province" v-validate="'alpha_spaces'" id="virtualSiteState" name="virtualSiteState" v-model="siteVirtualAddress.state" key="virtual-state-input" :state="!errors.has('virtualSiteState')"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3">
                      <b-form-group id="virtual-country-label" label-for="virtualSiteCountry" :invalid-feedback="errors.first('virtualSiteCountry')" :state="!errors.has('virtualSiteCountry')">
                        <label class="col-form-label">Address country <span v-b-popover.hover.html="'The <strong>address country</strong> is the country associated to the physical address of the site.'" class="fa fa-info-circle ml-7"></span></label>
                        <b-form-select name="virtualSiteCountry" id="virtualSiteCountry" v-validate="'alpha_spaces'" v-model="siteVirtualAddress.country" key="virtual-country-input" :state="!errors.has('virtualSiteCountry')">
                          <option value="">Select country</option>
                          <option v-for="(countryObj, indexOpt) in primaryCountryOptions" :key="indexOpt" :value="countryObj.text">{{ countryObj.text }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <!-- VIRTUAL ADDRESS CONTAINER ENDS HERE -->
                <!-- PHYSICAL ADDRESS CONTAINER STARTS HERE -->
                <div v-else-if="newSite.type && newSite.type.toLowerCase() == 'physical'" id="physical-site-container" class="site-address-elements">
                  <b-row>
                    <b-col cols="8">
                      <b-form-group id="physical-address-label" label="Address" label-for="physicalSiteAddress" :invalid-feedback="errors.first('physicalSiteAddress')" :state="!errors.has('physicalSiteAddress')">
                        <b-form-input type="text" placeholder="Address" v-validate="'required'" id="physicalSiteAddress" name="physicalSiteAddress" v-model="sitePhysicalAddress.address" :state="!errors.has('physicalSiteAddress')" class="required" key="physical-address-input"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="4" class="pl-0">
                      <b-form-group id="physical-city-label" label="City" label-for="physicalSiteCity" :invalid-feedback="errors.first('physicalSiteCity')" :state="!errors.has('physicalSiteCity')">
                        <b-form-input type="text" placeholder="City" v-validate="'required|alpha_spaces'" id="physicalSiteCity" name="physicalSiteCity" v-model="sitePhysicalAddress.city" :state="!errors.has('physicalSiteCity')" class="required" key="physical-city-input"> </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="3" class="custom-width">
                      <b-form-group id="physical-zip-label" label="Zip / Postal code" label-for="physicalSiteZip" :invalid-feedback="errors.first('physicalSiteZip')" :state="!errors.has('physicalSiteZip')">
                        <b-form-input type="text" placeholder="Zip / Postal code" v-validate="'required|alpha_num'" id="physicalSiteZip" name="physicalSiteZip" v-model="sitePhysicalAddress.zipcode" :state="!errors.has('physicalSiteZip')" class="required" key="physical-zip-input"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3" class="custom-width">
                      <b-form-group id="physical-state-label" label="State / Province" label-for="physicalSiteState" :invalid-feedback="errors.first('physicalSiteState')" :state="!errors.has('physicalSiteState')">
                        <b-form-input type="text" placeholder="State / Province" v-validate="'required|alpha_spaces'" id="physicalSiteState" name="physicalSiteState" v-model="sitePhysicalAddress.state" :state="!errors.has('physicalSiteState')" class="required" key="physical-state-input"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3" class="custom-width-country">
                      <b-form-group id="physical-country-label" label-for="physicalSiteCountry" :invalid-feedback="errors.first('physicalSiteCountry')" :state="!errors.has('physicalSiteCountry')">
                        <label class="col-form-label">Address country <span v-b-popover.hover.html="'The <strong>address country</strong> is the country associated to the physical address of the site.'" class="fa fa-info-circle ml-7"></span></label>
                        <b-form-select class="select-arrow" v-validate="'required|alpha_spaces'" id="physicalSiteCountry" name="physicalSiteCountry" v-model="sitePhysicalAddress.country" :state="!errors.has('physicalSiteCountry')" key="physical-country-input">
                          <option v-for="(countryObj, indexOpt) in primaryCountryOptions" :key="indexOpt" :value="countryObj.text">{{ countryObj.text }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3" class="custom-width-phone">
                      <b-form-group id="physical-phone-label" label="Phone" :invalid-feedback="siteAddressPhoneError ? 'Please enter a valid phone number.' : ''" :state="!siteAddressPhoneError">
                        <vue-tel-input
                          class="p-0 bg"
                          :preferredCountries="['us', 'ca']"
                          :placeholder="'(      )  '"
                          @onInput="onInputPhone"
                          v-model="sitePhysicalAddress.phoneNumber"
                          v-bind:class="{
                            input: true,
                            'is-invalid': siteAddressPhoneError
                          }"
                        ></vue-tel-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="pt-0">
                      <div class="form-group mb-0">
                        <label class="col-form-label d-block pt-0">Hours of operation</label>
                        <b-row>
                          <b-col cols="4" class="p-0">
                            <div class="btn-group week-days" role="group">
                              <button v-for="(day, index) in weekDays" :value="day.value" :key="index" type="button" class="btn btn-outline-dark btn-sm" :class="siteOperationDays.includes(day.value) ? 'active' : ''" @click="addEditOperationDays(day.value)">
                                {{ day.text }}
                              </button>
                            </div>
                          </b-col>
                          <b-col cols="8" class="p-0">
                            <div class="form-group mb-0">
                              <label>START</label>
                              <vueTimepicker format="hh:mm A" :minute-interval="10" v-model="siteOperationStartTime" class="ml-5"></vueTimepicker>
                              <label class="ml-20 mr-5">END</label>
                              <vueTimepicker format="hh:mm A" :minute-interval="10" v-model="siteOperationEndTime"></vueTimepicker>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row v-if="!validateSiteOperationHours"><b-col cols="12" class="p-0 mt-0 invalid-feedback d-block">Please specify valid hours of operation</b-col></b-row>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <!-- PHYSICAL ADDRESS CONTAINER ENDS HERE -->
              </b-col>
            </b-row>

            <!-- Principal Investigator -->
            <b-row class="form-card mt-15">
              <b-col cols="12" class="sec_text fs-16 pb-10">
                <b>Principal Investigator</b>
              </b-col>
              <b-col cols="3" v-if="newSite && newSite.sitePI && !Object.keys(newSite.sitePI).length > 0">
                <div class="btn-wrapper" :class="{ disabled: !isPiMemberLoaded }" @click="addTeam(null, 'pi')">
                  <i class="fa fa-plus"></i>
                  <span class="cursor_pointer">
                    <span class="btn-text">Add</span>
                  </span>
                </div>
              </b-col>
              <b-col v-else class="p-0">
                <b-row>
                  <b-col class="selected-filelds">NAME</b-col>
                  <b-col class="selected-filelds">EMAIL</b-col>
                  <b-col class="selected-filelds">ROLE</b-col>
                  <b-col class="selected-filelds">BLINDED</b-col>
                  <b-col class="selected-filelds"></b-col>
                </b-row>
                <b-row class="selectedTeam">
                  <b-col>
                    <span>
                      <b>{{ newSite.sitePI.firstName }} {{ newSite.sitePI.lastName }}</b>
                    </span>
                  </b-col>
                  <b-col class="word-break">
                    <span>{{ newSite.sitePI.username }}</span>
                  </b-col>
                  <b-col>{{ userRole[newSite.sitePI.userRole] }}</b-col>
                  <b-col>{{ newSite.sitePI.blinded ? "Blinded" : "Unblinded" }}</b-col>
                  <b-col>
                    <b-row>
                      <b-col class="edit-btn" @click="editMember(newSite.sitePI, 'pi')">Edit</b-col>
                      <b-col
                        ><span class="trash-icon" @click="removeMember('pi')"><img data-v-0ceadbe4="" src="static/img/econsent/delete.svg"/></span
                      ></b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- Site Team -->
            <b-row class="form-card mt-15">
              <b-col cols="12" class="sec_text fs-16 pb-10">
                <b>Site Team</b>
              </b-col>
              <b-col cols="12" class="p-0" v-if="newSite && newSite.siteTeam && newSite.siteTeam.length > 0">
                <b-row>
                  <b-col class="selected-filelds">NAME</b-col>
                  <b-col class="selected-filelds">EMAIL</b-col>
                  <b-col class="selected-filelds">ROLE</b-col>
                  <b-col class="selected-filelds">BLINDED</b-col>
                  <b-col class="selected-filelds"></b-col>
                </b-row>
                <b-row class="selectedTeam" v-for="(m, index) in newSite.siteTeam" :key="index">
                  <b-col>
                    <span>
                      <b>{{ m.firstName }} {{ m.lastName }}</b>
                    </span>
                  </b-col>
                  <b-col class="word-break">
                    <span>{{ m.username }}</span>
                  </b-col>
                  <b-col>{{ userRole[m.userRole] }}</b-col>
                  <b-col>{{ m.blinded ? "Blinded" : "Unblinded" }}</b-col>
                  <b-col>
                    <b-row>
                      <b-col class="edit-btn" @click="editMember(newSite.siteTeam, 'team')">Edit</b-col>
                      <b-col
                        ><span class="trash-icon" @click="removeMember('team', index)"><img data-v-0ceadbe4="" src="static/img/econsent/delete.svg"/></span
                      ></b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="3" :class="{ 'pt-12': newSite.siteTeam.length > 0 }">
                <div class="btn-wrapper" :class="{ disabled: !isSiteMemberLoaded }" @click="addTeam(null, 'team')">
                  <i class="fa fa-plus"></i>
                  <span class="cursor_pointer">
                    <span class="btn-text">Add</span>
                  </span>
                </div>
              </b-col>
            </b-row>
            <b-row class="pt-50 float-r">
              <b-btn class="btn br-1 fs-14" variant="outline-primary" @click="researchSiteLoad()">Cancel</b-btn>
              <b-btn id="createAndInvite" class="btn btn-primary create-btn fs-14 ml-10" type="submit" :disabled="disabledButton" v-on:click="setCreateSiteButtonDisabled()">Create site and invite investigators</b-btn>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
      <!-- add site team memeber modal -->
      <add-site-team-members
        :isPopupEnabled="siteTeamMemberModalPopUp"
        :options="{
          role: this.addTeamOptions.role,
          title: this.addTeamOptions.title
        }"
        @getSiteTeamSelected="getSiteTeamSelected"
        :allActivePis="allActivePis"
        :allActiveSiteTeamMember="allActiveSiteTeamMember"
        @searchForMember="searchForMember"
        :isRoleDropdownDisabled="true"
      >
      </add-site-team-members>
    </b-container>
  </div>
</template>

<script>
import findIndex from "lodash/findIndex";
import swal from "sweetalert2";
import toastr from "toastr";
import _ from "lodash";
import vueTimepicker from "vue2-timepicker";
import addSiteTeamMembers from "@/components/research-team/add-site-team-members";
import ApprovedLanguageSelect from "./approved-language-select";
import { v4 as uuidv4 } from "uuid";
const dict = {
  custom: {
    physicalSiteAddress: {
      required: "Site address is required"
    },
    physicalSiteCity: {
      required: "Site city is required",
      alpha_spaces: "Site city may only contain alphabetic characters as well as spaces."
    },
    physicalSiteZip: {
      required: "Site zip/postal code is required",
      alpha_num: "Site zip/postal code may only contain alpha-numeric characters."
    },
    physicalSiteState: {
      required: "Site state/province is required",
      alpha_spaces: "Site state/province may only contain alphabetic characters as well as spaces."
    },
    physicalSiteCountry: {
      required: "Site address country is required",
      alpha_spaces: "Site address country may only contain alphabetic characters as well as spaces."
    },
    virtualSiteCity: {
      alpha_spaces: "Site city may only contain alphabetic characters as well as spaces."
    },
    virtualSiteState: {
      alpha_spaces: "Site state/province may only contain alphabetic characters as well as spaces."
    },
    virtualSiteCountry: {
      alpha_spaces: "Site address country may only contain alphabetic characters as well as spaces."
    }
  }
};
export default {
  name: "add-research-site",
  props: ["addSite"],
  components: {
    ApprovedLanguageSelect,
    vueTimepicker,
    addSiteTeamMembers
  },
  computed: {
    validateSiteOperationHours() {
      const sod = this.siteOperationDays.length;
      let isValid = false;
      if (sod == 0 && this.siteOperationStartTime.hh === "" && this.siteOperationStartTime.mm === "" && this.siteOperationStartTime.A === "" && this.siteOperationEndTime.hh === "" && this.siteOperationEndTime.mm === "" && this.siteOperationEndTime.A === "") {
        isValid = true;
      } else if (sod > 0 && this.siteOperationStartTime.hh !== "" && this.siteOperationStartTime.mm !== "" && this.siteOperationStartTime.A !== "" && this.siteOperationEndTime.hh !== "" && this.siteOperationEndTime.mm !== "" && this.siteOperationEndTime.A !== "") {
        isValid = true;
      } else {
        isValid = false;
      }
      return isValid;
    },
    approvedLanguagesList() {
      if (!this.approvedLanguage) {
        return [];
      }
      if (!this.approvedLanguage.length) {
        return [];
      }
      const sortedLanguages = _.sortBy(this.approvedLanguage, "name");
      return sortedLanguages.filter(language => language.display_name.toLowerCase().includes(this.searchedLanguage.toLowerCase()));
    }
  },
  data() {
    return {
      requestId: uuidv4(),
      disabledButton: false,
      open: false,
      studyId: this.$route.params.studyId,
      siteTypes: [
        { text: "Select", value: null, disabled: true },
        { text: "Virtual", value: "Virtual" },
        { text: "Physical", value: "Physical" }
      ],
      siteSubTypes: [
        { text: "Select sub-type", value: null, disabled: true },
        { text: "Live", value: "LIVE" },
        { text: "Test", value: "TEST" }
      ],
      isDisplayApprovedLanguageCheckBoxes: false,
      selectedCountryLanguages: {},
      searchedLanguage: "",
      languagesFilter: [],
      approvedLanguages: [],
      selectedLanguages: [],
      approvedLanguage: [],
      teamRoles: [
        { text: "Select", value: null, disabled: true },
        { text: "Sub-Investigator", value: "SubPi" },
        { text: "Study Coordinator", value: "StudyCoordinator" },
        { text: "Home Health", value: "HomeHealth" },
        { text: "Site - Data Lock", value: "SiteDataLock" },
        { text: "Call Center", value: "CallCenter" },
        { text: "Rater", value: "Rater" }
      ],
      newSite: {
        name: "",
        userSiteId: "",
        type: null,
        siteSubType: null,
        sitePI: {},
        siteTeam: [],
        countryList: [],
        primaryCountry: null
      },
      actualCountriesObj: [],
      primaryCountryOptions: [],
      filterCountriesOptions: [],
      selectedIndex: -1,
      phoneNumber: "",
      actualOptions: [],
      oldValuePrimary: null,
      primaryCountryType: null,
      primaryCountryGroupId: null,
      selectedLanguageName: "English (US)",
      sitePhysicalAddress: {
        address: "",
        city: "",
        zipcode: "",
        state: "",
        country: "",
        phoneNumber: ""
      },
      siteVirtualAddress: {
        city: "",
        state: "",
        country: "",
        isAllowOtherRegionParticipant: false
      },
      siteAddressPhoneError: false,
      weekDays: [
        { value: "1", text: "S" },
        { value: "2", text: "M" },
        { value: "3", text: "T" },
        { value: "4", text: "W" },
        { value: "5", text: "T" },
        { value: "6", text: "F" },
        { value: "7", text: "S" }
      ],
      siteOperationDays: [],
      siteOperationStartTime: {
        hh: "",
        mm: "",
        A: ""
      },
      siteOperationEndTime: {
        hh: "",
        mm: "",
        A: ""
      },
      siteTeamMemberModalPopUp: false,
      addTeamOptions: {},
      allActivePis: null,
      allActiveSiteTeamMember: null,
      isPiMemberLoaded: false,
      isSiteMemberLoaded: false,
      userRole: {
        Pi: "Principal Investigator",
        SubPi: "Sub-Investigator",
        StudyCoordinator: "Study Coordinator",
        HomeHealth: "Home Health",
        SiteDataLock: "Site - Data Lock",
        CallCenter: "Call Center",
        Rater: "Rater"
      },
      canSiteTeamAddParticipant: true,
      canSiteTeamAddDocuments: true,
      canSiteTeamDownloadEsourceDocs: true
    };
  },
  mounted() {
    window.$('[data-toggle="popover"]').popover();
    this.$validator.localize("en", dict);
    this.getStudyDetails();
    this.getSiteTeamMembersDetail();
    this.getGlobalSiteSetting();
  },
  watch: {
    "newSite.primaryCountry": function() {
      this.populateApprovedLanguageDropdown();
    },
    approvedLanguage() {
      this.selectedLanguages = [];
    }
  },
  methods: {
    setCreateSiteButtonDisabled() {
      this.disabledButton = true;
    },
    updateParentOpen() {
      this.open = false;
    },
    getSiteTeamMembersDetail() {
      this.$api.getSiteTeamMembers(this.studyId, this.siteId, "pi").then(response => {
        this.allActivePis = response.body;
        this.isPiMemberLoaded = true;
      });
      this.$api.getSiteTeamMembers(this.studyId, this.siteId, "siteTeam").then(response => {
        const resp = response.body;
        const siteTeam = this.newSite.siteTeam;
        this.allActiveSiteTeamMember = resp.filter(function(x) {
          return !siteTeam.find(function(y) {
            return y.id == x.id;
          });
        });
        this.isSiteMemberLoaded = true;
      });
    },
    selectedCountryLanguage(event) {
      this.selectedCountryLanguages[event.countryId] = event.selectedLanguage;
      delete this.selectedCountryLanguages[event.previousCountryId];
    },
    onChangeLanguageFilter(language, countryId) {
      const optionIndex = this.languagesFilter.findIndex(element => !!element && element.language_id === language.language_id);
      if (optionIndex === -1) {
        this.languagesFilter.push(language);
      } else {
        this.languagesFilter.splice(optionIndex, 1);
      }
      this.selectedLanguages = this.languagesFilter;
      this.selectedCountryLanguages[countryId] = this.languagesFilter;
    },
    selectDefaultLanguage(countryId) {
      this.selectedLanguages = [];
      const defaultLanguage = this.approvedLanguage.find(e => e.languageName === this.selectedLanguageName);
      if (defaultLanguage !== undefined) {
        const languageIndex = this.approvedLanguage.findIndex(e => e.is_default === true);
        this.onChangeLanguageFilter(this.approvedLanguage[languageIndex], countryId);
      }
    },
    populateApprovedLanguageDropdown() {
      this.isDisplayApprovedLanguageCheckBoxes = true;
      this.selectedCountryLanguages = {};
      this.languagesFilter = [];
      this.approvedLanguage = [];
      this.approvedLanguage = this.approvedLanguages[this.newSite.primaryCountry];
    },
    selectPrimary(event) {
      //PRIMARY COUNTRY TYPE & GROUP ID
      this.primaryCountryGroupId = this.getCountryGroupId(event.target.value);
      this.primaryCountryType = this.getCountryType(event.target.value);
      this.oldValuePrimary = event.target.value;
      //PREPARE ADDITIONAL COUNTRY DROPDOWN OPTIONS (SELECTED COUNTRIES WILL NOT BE SHOWN IN ADDITIONAL OPTIONS)
      const additionalCountryOptions = this.additionCountryOptions(event.target.value);
      if (additionalCountryOptions.length > 0) {
        this.filterCountriesOptions[0] = additionalCountryOptions;
      }
      //Remove additional drop-downs if any
      this.newSite.countryList = [];
    },
    selectCountry(element, index) {
      //CHECK THE data sovereignty/privacy/storage restriction
      if (this.getCountryGroupId(element.target.value) != this.primaryCountryGroupId) {
        //CHECK THE DATA RESTRICTION (Only type 2 and 3 has data restriction)
        const additionalCountryType = this.getCountryType(element.target.value);

        if ((this.primaryCountryType == 2 || this.primaryCountryType == 3) && additionalCountryType != this.primaryCountryType) {
          toastr.error("This country follows different data storage and/or privacy rules than the one that has already been selected. Please create a separate site for this country.");
        } /* if(this.primaryCountryType==1 && (additionalCountryType == 2 || additionalCountryType == 3)) */ else {
          toastr.error("This country has data storage and/or privacy restrictions. Please create a separate site for this country.");
        }
        this.$nextTick(function() {
          // DOM updated
          this.newSite.countryList[index].id = this.newSite.countryList[index].previousValue;
        });
        return;
      }
      this.newSite.countryList[index].previousValue = element.target.value;
      //UPDATE THE OTHER ADDITIONAL COUNTRY OPTIONS BY REMOVING THE ALREADY SELECTED COUNTRIES
      for (let i = 0; i < this.filterCountriesOptions.length; i++) {
        const newRow = _.cloneDeep(this.filterCountriesOptions[i]);
        for (let k = 0; k < newRow.length; k++) {
          if (index != i && element.target.value == newRow[k].value) {
            newRow.splice(k, 1);
          }
        }
        this.$set(this.filterCountriesOptions, i, newRow);
      }
    },
    checkForNullIds() {
      for (let i = 0; i < this.newSite.countryList.length; i++) {
        if (this.newSite.countryList[i].id == null) {
          this.newSite.countryList.splice(i, 1);
        }
      }
    },
    additionCountryOptions(primaryCountry) {
      const self = this;
      return this.primaryCountryOptions.filter(c => {
        return c.value !== primaryCountry && !_.includes(_.map(self.newSite.countryList, "id"), c.value);
      });
    },
    processCountries(countries) {
      const listOfCountries = [];
      countries.map(c => {
        listOfCountries.push({ text: c.countryName, value: c.countryId });
      });
      return listOfCountries;
    },
    sortCountries(countries) {
      countries.map((c, index) => {
        if (c && (c.text == "US" || c.text == "United States")) {
          countries.splice(0, 0, c);
          countries.splice(index + 1, 1);
        }
      });
      return countries;
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.actualCountriesObj = response.body.countryList;

          //PRIMARY COUNTRY DROPDOWN OPTIONS
          this.primaryCountryOptions = this.processCountries(this.actualCountriesObj);
          this.primaryCountryOptions = this.sortCountries(this.primaryCountryOptions);
          //Approved Language
          this.approvedLanguages = response.body.approvedLanguages;

          //PREPARE ADDITIONAL COUNTRY DROPDOWN OPTIONS (SELECTED COUNTRIES WILL NOT BE SHOWN IN ADDITIONAL OPTIONS)
          const additionalCountryOptions = this.additionCountryOptions(this.newSite.primaryCountry);
          if (additionalCountryOptions.length > 0) {
            this.filterCountriesOptions[0] = additionalCountryOptions;
          }
        },
        () => {
          toastr.error("Error occurred while fetching Countries.");
        }
      );
    },
    processCountriesForSites(data) {
      this.actualCountriesObj.forEach((c, index) => {
        data.countryList.forEach((item, i) => {
          if (c.countryId == item.id) {
            data.countryList[i] = this.actualCountriesObj[index];
          }
        });
      });
      return data;
    },
    validateCountries() {
      if (this.newSite.countryList.length == 0) {
        return;
      }
      const nullValues = this.newSite.countryList.filter(c => {
        return c.id == null;
      });
      return nullValues.length > 0;
    },
    validateCountriesLanguage() {
      let nullValues = false;
      this.newSite.countryList.forEach(value => {
        if (!this.selectedCountryLanguages[value.id] || this.selectedCountryLanguages[value.id].length == 0) {
          nullValues = true;
          return false;
        }
      });
      return nullValues;
    },
    validateBeforeSubmit() {
      this.disabledButton = true;
      if (this.newSite.type && this.newSite.type.toLowerCase() == "physical" && (this.siteAddressPhoneError || !this.validateSiteOperationHours)) {
        this.disabledButton = false;
        return;
      }
      this.$validator.validateAll().then(result => {
        if (this.errors.items.length > 0) {
          this.disabledButton = false;
        } 
        if (result) {
          if (this.validateCountries()) {
            this.disabledButton = false;
            toastr.error("Please select country from additional dropdown or remove it.");
            return;
          }
          if (this.validateCountriesLanguage()) {
            this.disabledButton = false;
            toastr.error("Approved languages are required.");
            return;
          }
          let data = JSON.parse(JSON.stringify(this.newSite));
          data.countryList.push({ id: this.newSite.primaryCountry });
          data = this.processCountriesForSites(data);

          //Add Address Details
          if (this.newSite.type && this.newSite.type.toLowerCase() == "physical") {
            data = {
              ...data,
              ...this.sitePhysicalAddress,
              operationHours: this.siteOperationDays.join(",") + " - " + this.getTimeString(this.siteOperationStartTime) + " - " + this.getTimeString(this.siteOperationEndTime)
            };
          } else {
            data = { ...data, ...this.siteVirtualAddress };
          }

          //Adding global site settings data
          data.canSiteTeamDownloadEsourceDocs = this.canSiteTeamDownloadEsourceDocs;
          data.canSiteTeamAddDocuments = this.canSiteTeamAddDocuments;
          data.canSiteTeamAddParticipant = this.canSiteTeamAddParticipant;
          //approved language
          data.approvedLanguages = this.selectedCountryLanguages;
          this.$api.postSiteDetailsFact(this.studyId, this.requestId, data).then(
            () => {
              this.disabledButton = true;
              this.$toastr.success("New Research Site created successfully");
              this.$router.push({ name: "list-research-site" });
            },
            error => {
              this.requestId = uuidv4();
              this.disabledButton = false;
              if (error.body.message !== "failed") {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while creating site");
              } else {
                const duplicateEmails = error.body.duplicateTeamMemberEmails;
                this.$toastr.error("Email id of site team member already exists");
                duplicateEmails.forEach(email => {
                  const duplicateIndex = findIndex(this.newSite.siteTeam, ["username", email]);
                  this.newSite.siteTeam[duplicateIndex].emailError = "Email already exists.";
                  this.$forceUpdate();
                });
              }
            }
          );
        }
      });
    },
    validateSiteTeam() {
      if (this.newSite.siteTeam && this.newSite.siteTeam.length > 0) {
        for (let i = 0; i < this.newSite.siteTeam.length; i++) {
          this.newSite.siteTeam[i].phoneNumber = this.newSite.siteTeam[i].phoneNumber.replace(/\s/g, "");
          if (this.newSite.siteTeam[i].emailError || this.newSite.siteTeam[i].phoneError) {
            this.$toastr.error(this.newSite.siteTeam[i].emailError || this.newSite.siteTeam[i].phoneError);
            return true;
          }
        }
      } else {
        return false;
      }
    },
    onInputPhone({ number, isValid }) {
      if (this.newSite.siteTeam[this.selectedIndex]) {
        this.newSite.siteTeam[this.selectedIndex].phoneError = false;
      }

      this.$forceUpdate();
      if (!isValid && number.length > 0) {
        this.newSite.siteTeam[this.selectedIndex].phoneError = "Please enter a valid phone number.";
        this.$forceUpdate();
      } else {
        this.newSite.siteTeam[this.selectedIndex].phoneError = false;
        this.$forceUpdate();
      }
    },

    checkIndex(index) {
      this.selectedIndex = index;
      this.$forceUpdate();
    },
    addCountry() {
      if (this.selectedLanguages.length == 0) {
        toastr.error("Approved languages are required.");
        return;
      }
      const ifNUllEntryExists = this.newSite.countryList.filter(c => {
        return c.id == null;
      });
      if (ifNUllEntryExists.length != 0) {
        toastr.error("Please select additional country.");
        return;
      }
      if (this.validateCountriesLanguage()) {
        toastr.error("Approved languages are required.");
        return;
      }
      this.filterCountriesOptions[this.newSite.countryList.length] = this.additionCountryOptions(this.newSite.primaryCountry);
      this.newSite.countryList.push({ id: null, previousValue: null });
    },
    removeCountry(evt, index) {
      const self = this;
      evt.preventDefault();
      const removedCountryID = this.newSite.countryList[index].id;
      if (removedCountryID) {
        delete this.selectedCountryLanguages[removedCountryID];
      }
      this.newSite.countryList.splice(index, 1);
      this.newSite.countryList.filter((country, idx) => {
        this.filterCountriesOptions[idx] = this.primaryCountryOptions.filter(function(e) {
          return e.value != self.newSite.primaryCountry.value;
        });
      });
      // FILTER OUT COUNTRIES THOSE ARE SELECTED
      for (let i = 0; i < this.newSite.countryList.length; i++) {
        for (let k = 0; k < this.filterCountriesOptions.length; k++) {
          if (i != k) {
            for (let j = 0; j < this.filterCountriesOptions[k].length; j++) {
              if (this.filterCountriesOptions[k][j].value == this.newSite.countryList[i].value) {
                this.filterCountriesOptions[k].splice(j, 1);
              }
            }
          }
        }
      }
    },
    researchSiteLoad() {
      swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$router.push({ name: "list-research-site" });
        }
      });
    },
    getCountryType(countryId) {
      return _.result(
        _.find(this.actualCountriesObj, function(c) {
          return c.countryId === countryId;
        }),
        "countryType"
      );
    },
    getCountryGroupId(countryId) {
      return _.result(
        _.find(this.actualCountriesObj, function(c) {
          return c.countryId === countryId;
        }),
        "countryGroupId"
      );
    },
    onInputSiteAddressPhone({ number, isValid }) {
      if (!isValid && number.length > 0) {
        this.siteAddressPhoneError = true;
      } else {
        this.siteAddressPhoneError = false;
      }
    },
    addEditOperationDays(day) {
      const findDayIndex = _.findIndex(this.siteOperationDays, function(d) {
        return d == day;
      });

      if (findDayIndex == -1) {
        this.siteOperationDays.push(day);
      } else {
        this.$delete(this.siteOperationDays, findDayIndex);
      }
    },
    getTimeString(timeObj) {
      return `${timeObj.hh}:${timeObj.mm} ${timeObj.A}`;
    },
    addTeam(teamMember = null, role) {
      const promise1 = new Promise(resolve => {
        this.getSiteTeamMembersDetail();
        resolve("Success!");
      });
      promise1.then(() => {
        this.siteTeamMemberModalPopUp = !this.siteTeamMemberModalPopUp;
      });
      this.addTeamOptions = {
        role: role,
        title: role == "pi" ? "Add a Principal Investigator (PI)" : "Add site team"
      };

      if (teamMember != null) {
        this.$root.$emit("restoreMember", { member: teamMember, role: role });
      }
      this.$root.$emit("showActiveParticipantList");
    },
    getSiteTeamSelected(siteTeaMemberData, role) {
      if (role == "pi") {
        this.newSite.sitePI = siteTeaMemberData;
      } else {
        for (const x in siteTeaMemberData) {
          this.newSite.siteTeam.push(siteTeaMemberData[x]);
        }
      }
    },
    removeMember(member, index = null) {
      swal({
        title: "Are you sure you want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (member == "pi") {
            this.newSite.sitePI = {};
          } else {
            this.newSite.siteTeam.splice(index, 1);
          }
          const data = { member: member, index: index };
          this.$root.$emit("memberDeleted", data);
        }
      });
    },
    editMember(member, role) {
      this.addTeam(member, role);
    },
    searchForMember(data) {
      this.$api.searchSiteTeamMember(this.studyId, this.siteId, data).then(
        response => {
          if (data.role == "pi") {
            this.allActivePis = response.body;
          } else {
            this.allActiveSiteTeamMember = response.body;
            const resp = response.body;
            const siteTeam = this.newSite.siteTeam;
            this.allActiveSiteTeamMember = resp.filter(function(x) {
              return !siteTeam.find(function(y) {
                return y.id == x.id;
              });
            });
          }
        },
        () => {
          toastr.error("Error while fetching the records");
        }
      );
    },
    getGlobalSiteSetting() {
      this.$api.getGlobalSiteSettings(this.studyId).then(
        response => {
          if (response.body) {
            this.canSiteTeamAddParticipant = response.body.AddParticipantGlobalSettingEnabledFlag;
            this.canSiteTeamAddDocuments = response.body.DocumentGlobalSettingEnabledFlag;
            this.canSiteTeamDownloadEsourceDocs = response.body.DownloadEsourceDocsEnabledFlag;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting global settings.");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables.scss";

.link-color {
  color: #f16559;
  font-weight: 300;
}

.component {
  background-color: $color_content_background;
}
.set-color {
  color: lightgrey !important;
}

.form-card {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
}

.danger {
  color: #f16559;
}
.sec_text {
  color: #666669;
}

::placeholder {
  color: #c5d1d6 !important;
}

.bg {
  background: #f5f8fa !important;
}

.header-text {
  color: #666669 !important;
  opacity: 0.5;
  font-size: 14px;
}

.required {
  background: url("/static/img/required.svg") no-repeat right #f5f8fa !important;
}

.tel-required {
  position: absolute;
  top: 26px;
  right: 15px;
}
.select-arrow2 {
  background: url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px #f5f8fa !important;
}

.select-arrow {
  background: url("/static/img/required.svg") no-repeat right, url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px #f5f8fa !important;
}

.br-1 {
  border-radius: 100px;
}

.create-btn {
  border-radius: 100px;
  border: none;
  height: 40px;
  background-color: #4c8ce4;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.is-danger {
  border-color: #ff4848 !important;
  border-width: 1px !important;
}
#siteCountry {
  border-color: #ced4da;
  .is-danger {
    border-color: #ff4848 !important;
    border-width: 1px !important;
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 27px;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: 14px;
  right: 10px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: 14px;
  left: 5px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 10px;
  top: 14px;
}
.site-mem-add {
  position: relative;
  bottom: 20px;
  right: 10px;
}
.site-pi-add {
  position: relative;
  bottom: 5px;
  left: 8px;
  height: 50px;
}
.site-pi-lock {
  position: relative;
  bottom: 5px;
  left: 2px;
  height: 50px;
}
.info-msglock {
  position: relative;
  top: 14px;
  right: 5px;
}
.siteteam-info {
  position: relative;
  right: 15px;
}
.removelink {
  position: relative;
  left: 40px;
}
</style>
<style lang="scss">
#allowPartFromAnyRegion {
  vertical-align: middle;
  margin-right: 6px;
}
#languageSelectBox {
  position: relative;
}
.site-address-elements {
  margin-top: 20px;
  .form-group {
    .form-control {
      &.is-valid {
        border-color: #d3dfe4;
        &:focus {
          border-color: #d3dfe4;
          box-shadow: inherit;
        }
      }
    }

    label,
    label.col-form-label,
    legend.col-form-label {
      color: #666669 !important;
      opacity: 0.5;
      padding-bottom: inherit;
      padding-top: 0;
    }

    .vue-tel-input {
      &.is-invalid {
        border-color: #dc3545;
      }
    }

    .time-picker {
      width: 6em;
      .clear-btn {
        right: -8px;
      }
      input {
        &.display-time {
          border: 1px solid #d3dfe4;
          height: 33px !important;
          width: 6em;
        }
      }
    }

    select.custom-select {
      padding: 0.375rem 0.75rem;
      height: inherit;

      &#virtualSiteCountry {
        background: #fff url(/static/img/arrow-down.png) no-repeat center;
      }
    }
  }
  .week-days {
    button {
      padding: 4px 10px;
    }
    .btn-outline-dark {
      border-color: #e4e8eb;
    }

    .btn-outline-dark:hover,
    .btn-outline-dark:not(:disabled):not(.disabled):active,
    .show > .btn-outline-dark.dropdown-toggle {
      color: inherit;
      background: #e4e8eb;
      border-color: #e4e8eb;
    }
    .btn-outline-dark.active {
      border-color: #ffffff;
    }
    .btn-outline-dark:not(:disabled):not(.disabled):active:focus,
    .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-dark.dropdown-toggle:focus,
    .btn-outline-dark:focus {
      box-shadow: none;
    }
    .btn-outline-dark:not(:disabled):not(.disabled).active {
      background-color: #1e8fe1;
      border-color: #1e8fe1;
      color: #fff;
    }
  }
  .col-3 {
    &.custom-width {
      max-width: 20% !important;
      padding-right: 0;
    }
    &.custom-width-country {
      max-width: 21% !important;
      padding-right: 0;
    }

    &.custom-width-phone {
      flex: 0 0 33%;
      max-width: 33%;
      padding-right: 0;
      .vue-tel-input {
        border-color: #d3dfe4;
        .dropdown {
          padding: 8px;
        }
      }
    }
  }
}
.btn-wrapper {
  border-radius: 3px;
  border: 1.5px solid #c5d1d6;
  width: 67px;
  padding: 2px 2px;
  position: relative;
  cursor: pointer;
  .fa-plus {
    border: 1px solid #b0bac9;
    padding: 2px 3px;
    border-radius: 3px;
    background: #b0bac9;
    color: #fff;
  }
  .btn-text {
    padding-left: 10px;
    color: #4c8ce4;
  }
}
.selected-filelds {
  color: #666669;
  opacity: 0.5;
  font-size: 10px;
}
.selectedTeam {
  border-top: 1.5px solid rgba(211, 223, 228, 0.5);
  border-bottom: 1.5px solid rgba(211, 223, 228, 0.5);
  padding: 5px 0px;
  .edit-btn {
    border: solid 1px #c5d1d6;
    background-color: #ffffff;
    border-radius: 3px;
    color: #4c8ce4;
    text-align: center;
    padding: 2px;
    cursor: pointer;
  }
  .trash-icon {
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #c5d1d6;
    padding: 1px 2px 5px 1px;
    opacity: 0.7;
    cursor: pointer;
  }
}
.word-break {
  word-break: break-word;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.float-r {
  float: right;
}
.language-search-bar {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 8px;
  -webkit-margin-before: 8px;
}
#showCheckboxesLanguage {
  /* display: none; */
  background: #fff;
  position: absolute;
  width: 100% !important;
  height: auto;
  max-height: 250px;
  border-radius: 3px;
  padding: 10px;
  overflow: scroll;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}
.checkbox-label {
  padding-top: 2.8px;
}
.fakeclass {
  padding: 8px 10px 7px 8px;
  border-radius: 4px;
  border: solid 1px #d3dfe4;
}
.number-badge {
  width: 18px;
  height: 20px;
  flex-grow: 0;
  margin: 0 0 0 5px;
  padding: 0 5px;
  border-radius: 4px;
  background-color: #e0e0e0;
  color: #4c8ce4;
}
.selectHide {
  display: none;
}
</style>
